/* eslint-env browser, jquery */
/* global hljs, Auth0LockPasswordless, WOW */
// const debug = require('debug')('auth0:passwordless');
import container from 'modules/section-content';
import rg from 'modules/npm-component/require-global';
import domify from 'domify';
import 'bootstrap';
import Batch from 'batch';
import page from 'modules/ab-page-js';
import cookieDough from 'cookie-dough';
import splash from './passwordless-page.pug';
import metadata from './metadata.json';

const AB_TEST = 'cta-features-pgs';

let newLockAnimated;
let hasScrolled = false;

export default function register() {
  page('/passwordless', render, loadScripts, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function loadScripts(ctx, next) {
  const batch = new Batch();

  const cookie = cookieDough();
  const abExperiments = JSON.parse(cookie.get('ajs_ab.traits'));

  if (abExperiments && abExperiments[AB_TEST]) {
    window.metricsLib.track(`ab:viewed-${AB_TEST}`, {
      experiment_id: AB_TEST,
      variation_id: abExperiments[AB_TEST],
    });
  }


  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/passwordless/resources/highlight-fc8654573f.min.js', 'hljs', done);
  });

  batch.push(done => {
    rg('https://cdn.auth0.com/website/assets/pages/passwordless/resources/wow-a26a117ff5.min.js', 'wow', done);
  });

  batch.push(done => {
    rg(
      '//cdn.rawgit.com/iamdanfox/typetype/gh-pages/jquery.typetype.min.js',
      '$.fn.typetype',
      done
    );
  });

  batch.push(done => {
    rg('//cdn.auth0.com/js/lock/11.12.1/lock.min.js', 'lock', done);
  });

  batch.end(next);
}

function snippets(ctx, next) {
  toggleSwitch();

  hljs.configure({
    classPrefix: ''
  });

  $('pre code').each((i, block) => {
    hljs.highlightBlock(block);
  });

  const passwordlessLock = (options) => {
    let clientID = 'FFM5kk2bVwxecbTHWXt15zrRJIX2Kvp3';
    let domain = 'pwdlessdemo.auth0.com';
    return new Auth0LockPasswordless(clientID, domain, options);
  }

  const topLockOptions  = {
    container: 'top-iphone-lock'
  };
  const topLock = passwordlessLock(topLockOptions);
  topLock.show();

  const magicLinkOptions  = {
    container: 'magic-link-inline'
  };
  const impMagicLink = passwordlessLock(magicLinkOptions);
  impMagicLink.show();

  const impSMSOptions  = {
    container: 'sms-inline',
    allowedConnections: ['sms'],
    passwordlessMethod: 'code'
  };
  const impSMS = passwordlessLock(impSMSOptions);
  impSMS.show();

  const newLockAnimatedOptions  = {
    container: 'new-lock-animated'
  };
  newLockAnimated = passwordlessLock(newLockAnimatedOptions);
  newLockAnimated.show();

  const sdkiPhoneOptions  = {
    container: 'sdk-iphone-lock'
  };
  const sdkIphoneLock = passwordlessLock(sdkiPhoneOptions);
  sdkIphoneLock.show();

  const sdkNexusOptions  = {
    container: 'sdk-nexus-lock',
    allowedConnections: ['sms'],
    passwordlessMethod: 'code'
  };
  const sdkNexusLock = passwordlessLock(sdkNexusOptions);
  sdkNexusLock.show();

  // Before anything, set a content loaded flag

  const pwdLessElement = $('.passwordless-page');
  pwdLessElement.addClass('content-loaded');

  $('.intro [data-play]').on('click', () => {
    pwdLessElement.addClass('animating');

    setTimeout(() => {
      $('.intro').addClass('animation-start');

      setTimeout(() => {
        initIntroAnimation();
      }, 500);
    }, 1200);

    return false;
  });

  $('.intro [data-replay]').on('click', () => {
    resetAnimation();

    setTimeout(() => {
      $('.intro').removeClass('step1 step2 step3 step4 step5 step6 step7');
      $('section.intro .browser-lock.opened > .browser').attr('style', '');
    }, 500);

    setTimeout(() => {
      initIntroAnimation();
    }, 1500);

    return false;
  });

  // Image load check
  let iphone6Loaded = false;
  let iphone5Loaded = false;

  // Create new image
  const iphone6 = new Image();
  const iphone5 = new Image();

  iphone6.onload = () => {
    iphone6Loaded = true;

    if (iphone5Loaded) {
      $('.passwordless-page').addClass('phones-loaded');
    }
  };
  iphone5.onload = () => {
    iphone5Loaded = true;

    if (iphone6Loaded) {
      $('.passwordless-page').addClass('phones-loaded');
    }
  };

  // Attach the source last.
  // The onload function will now trigger once it's loaded.
  iphone6.src = 'https://cdn.auth0.com/website/assets/pages/passwordless/img/iphone-white-f63526398b.png';
  iphone5.src = 'https://cdn.auth0.com/website/assets/pages/passwordless/img/iphone5-top-banner-c865eb6e46.png';

  if ($(iphone6).prop('complete') && $(iphone5).prop('complete')) {
    $('.passwordless-page').addClass('phones-loaded');
  }

  // Init wow

  const wow = new WOW();
  wow.init();

  const currentHash = window.location.hash;
  const qna = $('.qna');
  const qnaQuestions = $('.questions > a');
  const qnaAnswers = $('.answers-inner > div');
  const prevEl = $('.prev-arrow');
  const nextEl = $('.next-arrow');

  prevEl.on('click', () => {
    const current = qnaQuestions.filter('.active');
    current.removeClass('active');

    if (current.prev().length && current.prev()[0].tagName == 'A') {
      current.prev().addClass('active');
      qnaAnswers
        .filter('.active')
        .removeClass('active')
        .prev()
        .addClass('active');
    } else {
      qnaQuestions.removeClass('active');
      qnaQuestions.eq(qnaQuestions.length - 1).addClass('active');
      qnaAnswers.removeClass('active');
      qnaAnswers.eq(qnaAnswers.length - 1).addClass('active');
    }
  });

  nextEl.on('click', () => {
    const current = qnaQuestions.filter('.active');
    current.removeClass('active');

    if (current.next().length) {
      current.next().addClass('active');
      qnaAnswers
        .filter('.active')
        .removeClass('active')
        .next()
        .addClass('active');
    } else {
      qnaQuestions.removeClass('active');
      qnaQuestions.eq(0).addClass('active');
      qnaAnswers.removeClass('active');
      qnaAnswers.eq(0).addClass('active');
    }
  });

  qnaQuestions.click(e => {
    e.preventDefault();
    if (e.target.tagName !== 'A') {
      var ref = $(e.target).parent()[0].hash;
    } else {
      var ref = e.target.hash;
    }
    history.pushState(null, null, ref);

    qnaQuestions.filter('.active').removeClass('active');
    qnaQuestions.filter(`[href="${ref}"]`).addClass('active');

    qnaAnswers.filter('.active').removeClass('active');
    qnaAnswers.filter(ref).addClass('active');
  });

  if (currentHash) {
    qnaQuestions.filter(`[href="${currentHash}"]`).addClass('active');
    qnaAnswers.filter(currentHash).addClass('active');
  } else {
    qnaQuestions.eq(0).addClass('active');
    qnaAnswers.eq(0).addClass('active');
  }

  next();
}

function initIntroAnimation() {
  const a0LockIntro = $('section.intro');

  a0LockIntro.addClass('step1');

  // After the animation started bind a scroll handler to detect a scroll
  $(document).one('scroll', () => {
    if (!hasScrolled) {
      hasScrolled = true;
    }
  });

  setTimeout(() => {
    a0LockIntro.addClass('step2');
  }, 2000);

  setTimeout(() => {
    a0LockIntro.addClass('step3');
  }, 3500);

  setTimeout(() => {
    a0LockIntro.addClass('step4');

    $('.intro .center-content input.auth0-lock-input').typetype('rickyrauch@gmail.com', {
      e: 0,
      callback() {
        newLockAnimated.update(state =>
          state.setIn(['cred', 'email', 'email'], 'rickyrauch@gmail.com')
        );
        newLockAnimated.requestGravatar('rickyrauch@gmail.com');
      }
    });
  }, 5800);

  setTimeout(() => {
    a0LockIntro.addClass('step5');

    $('.intro .center-content .auth0-lock-passwordless').addClass('auth0-lock-mode-loading');

    setTimeout(() => {
      $('.intro .center-content .auth0-lock-passwordless').addClass('auth0-lock-mode-completed');
    }, 2500);
  }, 11000);

  setTimeout(() => {
    a0LockIntro.addClass('step6');

    setTimeout(() => {
      a0LockIntro.find('.browser-lock.opened > .browser').hide();
    }, 400);
  }, 15500);

  setTimeout(() => {
    a0LockIntro.addClass('step7');
    $('.intro .center-content input.auth0-lock-input').backspace(20);
    newLockAnimated.update(state => state.setIn(['cred', 'email', 'email'], ''));

    if (!hasScrolled) {
      setTimeout(() => {
        $('html, body').animate(
          {
            scrollTop: $('#imp').offset().top
          },
          1000
        );
      }, 4800);
    }
  }, 17500);
}

function resetAnimation() {
  $('.auth0-lock-header-logo').show();
  $('.auth0-lock-header-bg-inner')
    .css('background-image', 'url(https://cdn.auth0.com/website/assets/pages/passwordless/img/badge-967bdae8f4.svg)')
    .removeClass('auth0-lock-no-grayscale');
  $('.auth0-lock-header-avatar')
    .addClass('auth0-lock-hide')
    .removeClass('animated fadeInDown');
  $('.auth0-lock-firstname').addClass('auth0-lock-hide');
  $('.auth0-lock-name').show();

  const animLock = $('.center-content .auth0-lock-passwordless');

  animLock.removeClass('auth0-lock-mode-loading');
  animLock.removeClass('auth0-lock-mode-completed');
}

function toggleSwitch() {
  // Handler for nav
  $('.nav-text > a').click(function(e) {
    e.preventDefault();
    const attr = $(this).attr('href');
    const $content = $('.code-content');
    // $content.removeClass("active");

    $('.get-code .active').removeClass('active');
    // Add active to link
    $(this).addClass('active');
    // Add active to tab
    $(`[data-lock="${attr.slice(1)}"]`).addClass('active');
    // Add active to code example
    $(attr).addClass('active');
  });

  // Handler for tabs
  $('.nav-lock .lock-tab').click(function(e) {
    const data = $(this).data('lock');
    // Remove all actives
    $('.get-code .active').removeClass('active');
    // Add active to link
    const link = $('.nav-text > a').filter(`[href="#${data}"]`);
    link.addClass('active');
    // Add active to tab
    $(this).addClass('active');
    // Add active to code
    $(link.attr('href')).addClass('active');
  });
}



// WEBPACK FOOTER //
// ./src/pages/passwordless/passwordless.js